import { type KyanIcon } from "@kyan/ui";

export type Theme = "light" | "dark";

export const themes: Record<
  Theme,
  {
    icon: KyanIcon;
    label: string;
  }
> = {
  light: {
    icon: "sun",
    label: "Light mode",
  },
  dark: {
    icon: "moon",
    label: "Dark mode",
  },
};
